module.exports = __webpack_public_path__ + "static/media/1691730813discord-icon-png.77755699.png";